import { apiSlice } from "app/api/apiSlice"


export const safetySettingsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['safetySettings'],
    endpoints: builder => ({
        getSafetySettings: builder.query({
            query: () => 'safety/settings',
            keepUnusedDataFor: 5,
            providesTags: ['safetySettings']
        }),
        setSafetySettings: builder.mutation({
            query: data => ({
                url: 'safety/settings',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['safetySettings']
        })
    })
})

export const {
    useGetSafetySettingsQuery,
    useLazyGetSafetySettingsQuery,
    useSetSafetySettingsMutation
} = safetySettingsApiSlice